<template>
  <div class="tag-info__wrapper">
    <div class="tag-info__top-section">
      <div class="tag-info__title-and-button-wrapper">
        <h1 class="tag-info__title">{{ Name }}</h1>
        <a-follow-tag-button
          :tag="actionIcon.props.tag"
          class="tag-info__follow-button"
          v-on="$listeners"
        />
      </div>

      <a-lazy-hydrate when-visible>
        <a-quicksearch :type="QUICKSEARCH_TYPE.TAGS" class="tag-info__search" />
      </a-lazy-hydrate>
    </div>

    <div v-if="!hideInfo" class="tag-info__bottom-section">
      <company-tag-header
        v-if="isCompanyTag"
        :company-details="CompanyInfo"
        class="tag-info__company-header"
      />

      <term-tag-header
        v-else-if="isTermTag"
        :term-details="TermInfo"
        class="tag-info__term-header"
      />
    </div>
  </div>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'
import { aspectRatios } from 'enums/aspectRatios'
import mixins from '@/utils/mixins'
import AQuicksearch, { QUICKSEARCH_TYPE } from 'shared/AQuickSearch'
import AFollowTagButton from 'shared/AFollowTagButton'
import CompanyTagHeader from '../CompanyTagHeader'
import TermTagHeader from '../TermTagHeader'

export const TAG_TYPE = {
  REGULAR: 'Regular',
  TERM: 'Term',
  COMPANY: 'Company'
}

export default {
  name: 'TagInfo',
  mixins: [mixins.urlGenerators],
  components: {
    AFollowTagButton,
    AQuicksearch,
    CompanyTagHeader,
    TermTagHeader
  },
  props: {
    Id: propValidator([PROP_TYPES.STRING]),
    Name: propValidator([PROP_TYPES.STRING]),
    IsFollowed: propValidator([PROP_TYPES.BOOLEAN]),
    CompanyInfo: propValidator([PROP_TYPES.OBJECT]),
    TermInfo: propValidator([PROP_TYPES.OBJECT]),
    hideInfo: propValidator([PROP_TYPES.BOOLEAN], false, false)
  },
  data() {
    return {
      TAG_TYPE,
      QUICKSEARCH_TYPE,
      aspectRatios,
      searchPhrase: ''
    }
  },
  computed: {
    actionIcon() {
      return {
        props: {
          tag: {
            id: this.Id,
            name: this.Name,
            isFollowed: this.IsFollowed
          }
        }
      }
    },
    isCompanyTag() {
      return !!this.CompanyInfo && !!this.CompanyInfo.Id
    },
    isTermTag() {
      return !!this.TermInfo && !!this.TermInfo.Id
    }
  },
  mounted() {
    this.$emit('mounted')
  }
}
</script>

<style lang="scss" scoped>
.tag-info__wrapper {
  @mixin one-line-top-section {
    flex-direction: row;

    .tag-info__search {
      margin-top: 0;
      width: 320px;
      margin-left: 37px;
    }
  }

  @mixin two-lines-top-section {
    flex-direction: column;

    .tag-info__search {
      width: 450px;
      max-width: 100%;
      margin: 20px auto 0;
    }
  }

  @mixin two-lines-top-section-mobile {
    flex-direction: column;

    .tag-info__search {
      width: 100%;
      margin: 0 0 10px 0;
      order: -1;
    }
  }

  .tag-info__top-section {
    display: flex;
    justify-content: space-between;

    @include one-line-top-section;

    @include desktop-md {
      @include two-lines-top-section;
    }

    @include tablet {
      @include two-lines-top-section-mobile;
    }
  }

  .tag-info__title-and-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .tag-info__title {
    margin-right: 15px;

    @include tablet {
      max-width: calc(100% - 54px);
    }
  }

  .tag-info__follow-button {
    margin-left: auto;
    margin-bottom: 15px;
    flex-shrink: 0;

    @include tablet {
      margin: 0;
    }
  }

  .tag-info__search {
    flex-shrink: 0;
  }

  .tag-info__bottom-section {
    margin-top: 20px;
  }

  .tag-info__company-header,
  .tag-info__term-header {
    margin-bottom: 40px;
  }
}
</style>
